/* ff-collection.js
   Mini-galerie des cartes produit : flèches gauche/droite pour faire
   défiler les photos (délégation d'événements, une seule écoute globale). */
(function () {
  function slideWidth(track) {
    var s = track.querySelector('.ff-gallery__slide');
    return s ? s.getBoundingClientRect().width : track.clientWidth;
  }

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest('[data-ff-prev], [data-ff-next]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      var gallery = btn.closest('.ff-gallery');
      var track = gallery && gallery.querySelector('[data-ff-track]');
      if (!track) return;

      var w = slideWidth(track);
      var next = btn.hasAttribute('data-ff-next');
      var atStart = track.scrollLeft < w * 0.5;
      var atEnd = track.scrollLeft + w * 1.5 >= track.scrollWidth;

      if (next && atEnd) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else if (!next && atStart) {
        track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: next ? w : -w, behavior: 'smooth' });
      }
    },
    false
  );
})();

/* FF — i18n : libellés multilingues pour la recherche (placeholder animé +
   suggestions). Ces textes étaient codés en dur en français ; on les traduit
   selon la langue active (<html lang>). Le français reste la valeur par défaut. */
var FF_LANG = (document.documentElement.lang || 'fr').slice(0, 2).toLowerCase();
var FF_I18N = ({
  fr: {
    phrases: [
      'Je cherche une applique murale pour la salle de bain…',
      'Je cherche un lustre pour le salon…',
      'Je cherche une suspension pour la salle à manger…',
      'Je cherche un plafonnier pour la chambre…',
      'Je cherche une applique en travertin…',
      'Je cherche une lampe de chevet…'
    ],
    focusPh: 'Rechercher un luminaire, une pièce…',
    products: 'Produits',
    collections: 'Collections',
    from: 'dès ',
    empty: function (q) { return 'Aucune suggestion pour « ' + q + ' »'; },
    seeAll: function (q) { return 'Voir tous les résultats pour « ' + q + ' »'; },
    numLocale: 'fr-FR'
  },
  en: {
    phrases: [
      'Looking for a wall light for the bathroom…',
      'Looking for a chandelier for the living room…',
      'Looking for a pendant for the dining room…',
      'Looking for a ceiling light for the bedroom…',
      'Looking for a travertine wall light…',
      'Looking for a bedside lamp…'
    ],
    focusPh: 'Search for a light, a room…',
    products: 'Products',
    collections: 'Collections',
    from: 'from ',
    empty: function (q) { return 'No suggestions for “' + q + '”'; },
    seeAll: function (q) { return 'See all results for “' + q + '”'; },
    numLocale: 'en-US'
  },
  es: {
    phrases: [
      'Busco un aplique para el baño…',
      'Busco una lámpara de araña para el salón…',
      'Busco una lámpara colgante para el comedor…',
      'Busco una lámpara de techo para el dormitorio…',
      'Busco un aplique de travertino…',
      'Busco una lámpara de noche…'
    ],
    focusPh: 'Buscar una lámpara, una habitación…',
    products: 'Productos',
    collections: 'Colecciones',
    from: 'desde ',
    empty: function (q) { return 'Sin sugerencias para «' + q + '»'; },
    seeAll: function (q) { return 'Ver todos los resultados para «' + q + '»'; },
    numLocale: 'es-ES'
  },
  it: {
    phrases: [
      "Cerco un'applique per il bagno…",
      'Cerco un lampadario per il soggiorno…',
      'Cerco una sospensione per la sala da pranzo…',
      'Cerco una plafoniera per la camera…',
      "Cerco un'applique in travertino…",
      'Cerco una lampada da comodino…'
    ],
    focusPh: 'Cerca una lampada, una stanza…',
    products: 'Prodotti',
    collections: 'Collezioni',
    from: 'da ',
    empty: function (q) { return 'Nessun suggerimento per «' + q + '»'; },
    seeAll: function (q) { return 'Vedi tutti i risultati per «' + q + '»'; },
    numLocale: 'it-IT'
  },
  de: {
    phrases: [
      'Wandleuchte fürs Badezimmer gesucht…',
      'Kronleuchter fürs Wohnzimmer gesucht…',
      'Pendelleuchte fürs Esszimmer gesucht…',
      'Deckenleuchte fürs Schlafzimmer gesucht…',
      'Wandleuchte aus Travertin gesucht…',
      'Nachttischlampe gesucht…'
    ],
    focusPh: 'Leuchte, Raum suchen…',
    products: 'Produkte',
    collections: 'Kollektionen',
    from: 'ab ',
    empty: function (q) { return 'Keine Vorschläge für „' + q + '“'; },
    seeAll: function (q) { return 'Alle Ergebnisse für „' + q + '“ anzeigen'; },
    numLocale: 'de-DE'
  }
})[FF_LANG] || null;
if (!FF_I18N) {
  FF_I18N = {
    phrases: [
      'Je cherche une applique murale pour la salle de bain…',
      'Je cherche un lustre pour le salon…',
      'Je cherche une suspension pour la salle à manger…',
      'Je cherche un plafonnier pour la chambre…',
      'Je cherche une applique en travertin…',
      'Je cherche une lampe de chevet…'
    ],
    focusPh: 'Rechercher un luminaire, une pièce…',
    products: 'Produits',
    collections: 'Collections',
    from: 'dès ',
    empty: function (q) { return 'Aucune suggestion pour « ' + q + ' »'; },
    seeAll: function (q) { return 'Voir tous les résultats pour « ' + q + ' »'; },
    numLocale: 'fr-FR'
  };
}

/* Header : repli de la 2e ligne (menu + liens) au scroll, ne laissant que
   la ligne logo + recherche + icônes. */
(function () {
  var header = document.querySelector('.shopify-section--header');
  if (!header) return;

  var TOP = 140; // au-dessus de ce seuil, le menu reste toujours affiché
  var DELTA = 8; // mouvement mini avant de réagir
  var COOLDOWN = 450; // verrou anti-rebond (le repli change la hauteur du header,
  //                     ce qui peut générer de faux événements de scroll)
  var lastY = window.scrollY;
  var locked = false;
  var ticking = false;

  function setCondensed(v) {
    if (header.classList.contains('is-condensed') === v) return;
    header.classList.toggle('is-condensed', v);
    locked = true;
    setTimeout(function () { locked = false; }, COOLDOWN);
  }

  function update() {
    ticking = false;
    var y = window.scrollY;

    if (y <= TOP) {
      // Près du haut : menu complet toujours visible
      setCondensed(false);
      lastY = y;
      return;
    }

    if (locked) return; // on ignore les faux événements pendant la transition

    if (y > lastY + DELTA) {
      // Scroll vers le bas : on replie le menu
      setCondensed(true);
      lastY = y;
    } else if (y < lastY - DELTA) {
      // Scroll vers le haut : le menu réapparaît, où qu'on soit
      setCondensed(false);
      lastY = y;
    }
  }

  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    },
    { passive: true }
  );

  update();
})();

/* Barre de recherche : placeholder animé « machine à écrire » qui enchaîne
   des exemples de recherche. En pause quand le champ est actif ou rempli. */
(function () {
  var input = document.querySelector('.ff-search input');
  if (!input) return;

  var phrases = FF_I18N.phrases;

  var reduce =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) {
    input.setAttribute('placeholder', phrases[0]);
    return;
  }

  var pi = 0;
  var ci = 0;
  var deleting = false;

  input.addEventListener('focus', function () {
    input.setAttribute('placeholder', FF_I18N.focusPh);
  });

  function tick() {
    // En pause tant que le champ est actif ou qu'une saisie est en cours
    if (document.activeElement === input || input.value) {
      setTimeout(tick, 700);
      return;
    }

    var full = phrases[pi];

    if (!deleting) {
      ci++;
      input.setAttribute('placeholder', full.slice(0, ci));
      if (ci >= full.length) {
        deleting = true;
        setTimeout(tick, 1700);
        return;
      }
      setTimeout(tick, 55 + Math.random() * 45);
    } else {
      ci--;
      input.setAttribute('placeholder', full.slice(0, ci));
      if (ci <= 0) {
        deleting = false;
        pi = (pi + 1) % phrases.length;
        setTimeout(tick, 350);
        return;
      }
      setTimeout(tick, 28);
    }
  }

  setTimeout(tick, 900);
})();

/* Recherche prédictive : suggestions en direct (produits + collections) via
   l'API /search/suggest.json de Shopify, sous la barre de recherche. */
(function () {
  var form = document.querySelector('.ff-search');
  var input = form && form.querySelector('input');
  if (!form || !input) return;

  var box = document.createElement('div');
  box.className = 'ff-sg';
  box.hidden = true;
  box.setAttribute('role', 'listbox');
  form.appendChild(box);

  var timer = null;
  var items = [];
  var active = -1;

  function money(v) {
    var n = parseFloat(v);
    if (isNaN(n)) return '';
    return n.toLocaleString(FF_I18N.numLocale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }
  function esc(str) {
    var d = document.createElement('div');
    d.textContent = str == null ? '' : str;
    return d.innerHTML;
  }
  function thumb(url) {
    if (!url) return '';
    var u = url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=92';
    return '<img src="' + u + '" alt="" loading="lazy">';
  }
  function hide() { box.hidden = true; active = -1; }
  function clearActive() { items.forEach(function (el) { el.classList.remove('is-active'); }); }
  function setActive(i) {
    clearActive();
    if (i < 0 || i >= items.length) { active = -1; return; }
    active = i;
    items[i].classList.add('is-active');
    items[i].scrollIntoView({ block: 'nearest' });
  }

  function render(data, q) {
    var r = (data && data.resources && data.resources.results) || {};
    var prods = r.products || [];
    var cols = r.collections || [];
    var html = '';
    if (prods.length) {
      html += '<p class="ff-sg__label">' + FF_I18N.products + '</p>';
      prods.forEach(function (p) {
        var img = (p.featured_image && p.featured_image.url) || p.image || '';
        var price = money(p.price_min || p.price);
        if (p.price_min && p.price_max && p.price_min !== p.price_max) price = FF_I18N.from + price;
        html += '<a class="ff-sg__item" role="option" href="' + p.url + '">' +
          '<span class="ff-sg__thumb">' + thumb(img) + '</span>' +
          '<span class="ff-sg__meta"><span class="ff-sg__t">' + esc(p.title) + '</span>' +
          (price ? '<span class="ff-sg__p">' + price + '</span>' : '') +
          '</span></a>';
      });
    }
    if (cols.length) {
      html += '<p class="ff-sg__label">' + FF_I18N.collections + '</p>';
      cols.forEach(function (c) {
        html += '<a class="ff-sg__col" role="option" href="' + c.url + '">' + esc(c.title) + '</a>';
      });
    }
    if (!prods.length && !cols.length) {
      html = '<p class="ff-sg__empty">' + FF_I18N.empty(esc(q)) + '</p>';
    }
    html += '<a class="ff-sg__all" role="option" href="/search?q=' + encodeURIComponent(q) + '&type=product">' + FF_I18N.seeAll(esc(q)) + '</a>';
    box.innerHTML = '<div class="ff-sg__inner">' + html + '</div>';
    items = [].slice.call(box.querySelectorAll('.ff-sg__item, .ff-sg__col, .ff-sg__all'));
    active = -1;
    box.hidden = false;
  }

  function fetchSuggest(q) {
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last';
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (input.value.trim() !== q) return; // réponse obsolète
        render(data, q);
      })
      .catch(function () { hide(); });
  }

  input.addEventListener('input', function () {
    var q = input.value.trim();
    clearTimeout(timer);
    if (q.length < 2) { hide(); return; }
    timer = setTimeout(function () { fetchSuggest(q); }, 180);
  });
  input.addEventListener('focus', function () {
    if (input.value.trim().length >= 2 && box.innerHTML) box.hidden = false;
  });
  input.addEventListener('keydown', function (e) {
    if (box.hidden || !items.length) return;
    if (e.key === 'ArrowDown') { e.preventDefault(); setActive(active + 1 >= items.length ? 0 : active + 1); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1 < 0 ? items.length - 1 : active - 1); }
    else if (e.key === 'Enter') { if (active >= 0 && items[active]) { e.preventDefault(); window.location.href = items[active].getAttribute('href'); } }
    else if (e.key === 'Escape') { hide(); }
  });
  document.addEventListener('click', function (e) {
    if (!form.contains(e.target)) hide();
  });
})();
